import { useMemo, useState } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import * as actionTypes from '../../../../redux/actionTypes'
import * as endpoints from '../../../../../_template/helpers/endpoints'
import { usersColumns } from './columns/_columns'
// import {RelayPoint} from '../core/_models'
import { KTCard, KTCardBody } from '../../../../../_template/helpers'
import { useSelector } from 'react-redux'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import { RPListSearchComponent } from '../components/header/RPSearchComponent'
import { useAppDispatch } from '../../../../hooks'
import { getAllFunction } from '../../../../redux/actions/commonCrud'
import PaginationComponent from '../../../../../_template/layout/components/pagination'
type Props = {
  eventKey?: string | undefined
}
type values = {
  role?: string | undefined
  phone?: string | undefined
  status?: string | undefined
  firstName?: string | undefined
  lastName?: string | undefined
  email?: string | undefined
}
const RelayPointTable: React.FC<Props> = ({ eventKey }) => {
  const relayPoint: IRelayPoint[] = useSelector(({ users }: { users: UsersState }) => {
    return users.relayPoints
  })
  const totalPages: number = useSelector(({ users }: { users: UsersState }) => {
    return users.totalPages
  })
  const [values, setValues] = useState<values | undefined>({
    status: eventKey === 'All' ? undefined : eventKey,
  })
  const handleChangeValues = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    })
  }
  // const isLoading = useQueryResponseLoading()
  const data: IRelayPoint[] = useMemo(() => relayPoint, [relayPoint])
  const columns = useMemo(() => usersColumns, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })
  const dispatch = useAppDispatch()
  const handleDispatch = () => {
    dispatch(getAllFunction(endpoints.userEndpoint, actionTypes.GET_ALL_USERS, values))
  }

  return (
    <KTCard>
      <KTCardBody className='py-4'>
        <div className='w-md-100'>
          <RPListSearchComponent
            values={values}
            handleChangeValues={handleChangeValues}
            handleDispatch={handleDispatch}
            eventKey={eventKey}
          />
        </div>

        <div className='table-responsive'>
          <table
            id='kt_table_users'
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
            {...getTableProps()}
          >
            <thead>
              <tr className='text-muted fw-bolder fs-7 text-uppercase gs-0'>
                {headers.map((column: ColumnInstance<IRelayPoint>) => (
                  <CustomHeaderColumn key={column.id} column={column} />
                ))}
              </tr>
            </thead>
            <tbody className='text-gray-500 fs-6' {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row: Row<IRelayPoint>, i) => {
                  prepareRow(row)
                  return <CustomRow row={row} key={`row-${i}-${row.id}`} />
                })
              ) : (
                <tr>
                  <td colSpan={7}>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No matching records found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <PaginationComponent
          values={values}
          setValues={setValues}
          endpoint={endpoints.relayPointEndpoint}
          actionType={actionTypes.GET_ALL_FRELAY_POINTS}
          totalPages={totalPages}
        />
        {/* {isLoading && <UsersListLoading />} */}
      </KTCardBody>
    </KTCard>
  )
}

export { RelayPointTable }
